const voiceCommunity = {
  // 获取侧栏房间列表 - 李健
  getSidebarRoomList: `/authApi/voiceforum/v1/homePage/joinRoom`,
  // 获取侧栏房间列表（包含频道列表） - 李健
  allRoomChannelList: `/authApi/voiceforum/v1/allRoomChannelList`,
  // 获取游戏绑定语音社区 - 李健
  getGameEntranceInfo: `/authApi/voiceforum/v1/entrance`,
  // 首页推荐房间 - 李健
  getRecommendRoom: `/authApi/voiceforum/v1/homePage/recommendRoom`,
  // 创建房间 - 李健
  userCreateRoom: `/authApi/voiceforum/v1/userCreateRoom`,
  // 社区语音房间 - 我创建的 - 李健
  myCreateRoom: `/authApi/voiceforum/v1/myCreateRoom`,
  // 社区语音房间 - 我管理的 - 李健
  myAdminRoom: `/authApi/voiceforum/v1/myAdminRoom`,
  // 社区语音房间 - 我加入的 - 李健
  myJoinRoom: `/authApi/voiceforum/v1/myJoinRoom`,
  // 社区语音房间 - 最经访问 - 李健
  userRecentlyVisitRoom: `/authApi/voiceforum/v1/roomVisitRecord`,
  // 社区语音房间 - 保存最经访问 - 李健
  saveVisitRecord: `/authApi/voiceforum/v1/saveVisitRecord`,
  // 社区语音首页 - 侧栏房间列表 - 李健
  allJoinRoom: `/authApi/voiceforum/v1/homePage/joinRoom`,
  // 社区语音首页 - 房间顺序调整 - 李健
  allRoomSort: `/authApi/voiceforum/v1/room/sort`,
  // 退出房间 - 李健
  existRoom: `/authApi/voiceforum/v1/existRoom`,
  // pc社区语音首页 banner和排行榜 - 李健
  homeBasic: `/authApi/voiceforum/v1/pcHomePage/basic`,
  // 获取sdk初始化信息 - 李健
  sdkInfo: `/authApi/voiceforum/v1/im/login`,
  // 获取频道信息 - 李健
  getChannelInfo: `/authApi/voiceforum/v1/channel`,
  // 语音频道模式切换 - 林加汉
  modelChange: `/authApi/voiceforum/v1/micChannel/modelChange`,
  // 频道用户列表 - 林加汉
  getChannelUsers: `/authApi/voiceforum/v1/channelMembers`,
  // 频道麦上用户列表 - 林加汉
  getChannelMicUsers: `/authApi/voiceforum/v1/micChannel/micSeatList`,
  // 自由上下麦模式-上下麦操作 - 林加汉
  micOperate: `/authApi/voiceforum/v1/micChannel/micOperate`,
  // 上麦申请 - 林加汉
  micApply: `/authApi/voiceforum/v1/micChannel/micApply`,
  // 上麦申请列表 - 林加汉
  applyList: `/authApi/voiceforum/v1/micChannel/applyList`,
  // 上麦审批 - 林加汉
  micApprove: `/authApi/voiceforum/v1/micChannel/micApprove`,
  // 上麦邀请 - 林加汉
  micInvite: `/authApi/voiceforum/v1/micChannel/micInvite`,
  // 通过邀请链接获取房间和频道信息 - 苏昕
  inviteDetail: `/authApi/voiceforum/v1/shareUrl/resolve`,
  // 接受上麦邀请 - 林加汉
  micReceiveInvite: `/authApi/voiceforum/v1/micChannel/micReceiveInvite`,
  // 查询当前用户拥有的所有权限 - 苏昕
  permission: `/authApi/voiceforum/permission/member/permission`,
  // 获取房间下面的频道列表 - 李健
  channelList: `/authApi/voiceforum/v1/channelList`,
  // 人员调度 - 林加汉
  dispatchUser: `/authApi/voiceforum/voice/dispatch`,
  // 踢人下麦 - 林加汉
  kickMic: `/authApi/voiceforum/voice/mic/kick`,
  // 禁言用户 - 林加汉
  muteUser: `/authApi/voiceforum/chat/mute`,
  // 解除用户禁言 - 林加汉
  unmuteUser: `/authApi/voiceforum/chat/unmute`,
  // 闭麦 - 林加汉
  closeMic: `/authApi/voiceforum/voice/mic/close`,
  // 解除闭麦 - 林加汉
  openMic: `/authApi/voiceforum/voice/mic/open`,
  // 查询目标用户的权限 - 苏昕
  userGroup: `/authApi/voiceforum/permission/member/group`,
  // 添加管理员权限 - 苏昕
  addGroup: `/authApi/voiceforum/permission/member/add`,
  // 移除管理员权限 - 苏昕
  removeGroup: `/authApi/voiceforum/permission/member/remove/batch`,
  // 将用户踢出频道 - 李健
  kickChannel: `/authApi/voiceforum/chat/kick/channel`,
  // 将用户踢出房间 - 李健
  kickRoom: `/authApi/voiceforum/chat/kick/room`,
  // 麦克风开关 - 林加汉
  micSwitch: `/authApi/voiceforum/v1/micChannel/micSwitch`,
  // 扬声器开关 - 林加汉
  speakerSwitch: `/authApi/voiceforum/v1/micChannel/speakerSwitch`,
  // 获取oss临时上传参数 - 林加汉
  ossSign: `/authApi/voiceforum/ossSign`,
  // 检查是否允许直接讲话 - 林加汉
  directSpeak: `/authApi/voiceforum/permission/check/directSpeak`,
  // 检查是否允许播放伴奏 - 林加汉
  playBgm: `/authApi/voiceforum/permission/check/playBgm`
};

export default voiceCommunity;
